import { ButtonHTMLAttributes, FC, ReactNode, useRef, MouseEvent } from 'react'
import { CircleActionButtonContainer } from './styles'

interface CircleActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  children: ReactNode;
  bg?: string;
} 

const CircleActionButton: FC<CircleActionButtonProps> = ({ label, children, onClick, disabled, bg, ...rest }) => {
  const btnRef = useRef<HTMLButtonElement>(null)

  const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    if(onClick) {
      event.stopPropagation()
      onClick(event)
    }
  }

  return (
    <CircleActionButtonContainer bg={bg} disabled={disabled} onClick={() => btnRef.current?.click()}>
      <button ref={btnRef} disabled={disabled} onClick={handleButtonClick} {...rest}>{children}</button>
      <span>{label}</span>
    </CircleActionButtonContainer>
  )
}

export default CircleActionButton